import { trimStart } from "./strings"

export const normalizeEan = (value: string) =>
  trimStart(value, "0").toUpperCase()
